// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { mediumRecipeId } from './MediumRecipe';
import { invResourceId } from './InvResource';
import { invProductId } from './InvProduct';
import { operatorId } from './Operator';
import { z } from 'zod';
export const mediumRecipeComponentId = (z.number());
export const mediumRecipeComponent = z.object({
    id: mediumRecipeComponentId,
    recipe_id: mediumRecipeId,
    resource_id: invResourceId,
    product_id: invProductId.nullable(),
    target_concentration_g_kg: z.string().nullable(),
    fixed_amount_g: z.string().nullable(),
    amount_unit: z.string(),
    is_optional: z.boolean(),
    instructions: z.string().nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const mediumRecipeComponentInitializer = z.object({
    id: mediumRecipeComponentId.optional(),
    recipe_id: mediumRecipeId,
    resource_id: invResourceId,
    product_id: invProductId.optional().nullable(),
    target_concentration_g_kg: z.string().optional().nullable(),
    fixed_amount_g: z.string().optional().nullable(),
    amount_unit: z.string().optional(),
    is_optional: z.boolean().optional(),
    instructions: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const mediumRecipeComponentMutator = z.object({
    id: mediumRecipeComponentId.optional(),
    recipe_id: mediumRecipeId.optional(),
    resource_id: invResourceId.optional(),
    product_id: invProductId.optional().nullable(),
    target_concentration_g_kg: z.string().optional().nullable(),
    fixed_amount_g: z.string().optional().nullable(),
    amount_unit: z.string().optional(),
    is_optional: z.boolean().optional(),
    instructions: z.string().optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=MediumRecipeComponent.js.map